// 契約済み一覧
import React from 'react';
import ProjectShelf from '../molecules/ProjectShelf';
import Heading from '../molecules/Heading';
import { ReceptionItem } from '../types/ProjectList';

interface Props {
  receptions?: ReceptionItem;
}

const ContractedList: React.FC<Props> = ({ receptions }) => {
  return (
    <div>
      <div className="p-lead mt-5">内容を確認したいローンを選択して下さい。</div>
      {receptions && (
        <>
          <Heading label="契約完了" size="m" />
          {Object.values(receptions).map((reception: any, index: number) => {
            return (
              <ProjectShelf
                name={reception.appl_name}
                r_id={reception.id}
                r_cd={reception.reception_cd}
                date={reception.application_date}
                loan_name={reception.loan.loan_name}
                loan_css={reception.loan.css}
                relationship={reception.relationship}
                current={reception.current}
                status={reception.status}
                agri_fund_name={reception.agri_fund_name}
                contract_method={reception.contract_method}
                contracts={reception.contracts}
                exists_contract={reception.exists_contract}
                is_open={false}
                key={index}
              />
            );
          })}
        </>
      )}
    </div>
  );
};

export default ContractedList;
